import PropTypes from 'prop-types'
import { idPropType } from './id-prop-type'
import { itemMappingPropType } from './item-mapping-prop-type'

/**
 * Proptype that represents a mapping of a collection of items to a particular section
 * @typedef {Object}                         sectionMappingPropType
 * @param   {idPropType}                     id                      - id of the section
 * @param   {Array.<itemMappingPropType>}    [items]                 - items array (id + section it belongs to)
 */
export const sectionMappingPropType = PropTypes.shape({
    id: idPropType.isRequired,
    items: PropTypes.arrayOf(itemMappingPropType)
})
